export enum APIMethodEnum {
  GET = "get",
  POST = "post",
  PUT = "put",
  PATCH = "patch",
  DELETE = "delete",
}

export const apiMethodColorStyles = {
  [APIMethodEnum.GET]: "bg-[#1F6B3C]/12 text-[#1F6B3C]",
  [APIMethodEnum.POST]: "bg-blue-900/12 text-blue-900",
  [APIMethodEnum.PUT]: "bg-[#BE451E]/12 text-[#BE451E]",
  [APIMethodEnum.PATCH]: "bg-warning/12 text-warning",
  [APIMethodEnum.DELETE]: "bg-red-700/12 text-red-700",
};

export const apiMethods = [
  {
    name: APIMethodEnum.GET,
    text: "Get Data",
  },
  {
    name: APIMethodEnum.POST,
    text: "Add new data",
  },
  {
    name: APIMethodEnum.PUT,
    text: "Replace data",
  },
  {
    name: APIMethodEnum.PATCH,
    text: "Update data",
  },
  {
    name: APIMethodEnum.DELETE,
    text: "Delete Data",
  },
];

export const httpModeColors = {
  [APIMethodEnum.GET]: "bg-green bg-opacity-12 text-green-dark",
  [APIMethodEnum.POST]: "bg-blue bg-opacity-12 text-blue-dark",
  [APIMethodEnum.PUT]: "bg-orange bg-opacity-12 text-orange-dark",
  [APIMethodEnum.DELETE]: "bg-red bg-opacity-12 text-red-dark",
  [APIMethodEnum.PATCH]: "bg-yellow bg-opacity-12 text-yellow-dark",
};
